import React, { useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

function MyQuillWithUpload({ value, onChange, height = 150, className = '', placeholder = '' }) {
  const quillRef = useRef();

  const imageHandler = () => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      if (file) {
        // Upload lên server, lấy URL trả về
        const formData = new FormData();
        formData.append("image", file);

        // Thay bằng API upload của bạn, ví dụ bên dưới là fake API
        const res = await fetch("/api/upload", { method: "POST", body: formData });
        const data = await res.json();
        const url = data.url;

        // Chèn vào vị trí con trỏ editor
        const editor = quillRef.current.getEditor();
        const range = editor.getSelection();
        editor.insertEmbed(range.index, "image", url);
      }
    };
  };

  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image", "video"],
      ["clean"],
    ],
  };

  return (
    <ReactQuill
      ref={quillRef}
      value={value}
      onChange={onChange}
      modules={quillModules}
      theme="snow"
      className={className}
      placeholder={placeholder}
      style={{ height, marginBottom: 40 }}
    />
  );
}

export default MyQuillWithUpload;
